export const reOrder = (data) => {
  return data
    .filter((o) => o.PP === 0)
    .sort((a, b) => (a.PUNTO > b.PUNTO ? 1 : -1))
    .concat(
      data.filter((o) => o.PP > 0).sort((a, b) => (a.PP > b.PP ? 1 : -1))
    );
};
